<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <v-card id="projectsCard">
          <v-card-title id="tableTitle" class="primary--text" style="font-size: 1.5em; padding: 20px">{{ $t("nav.projects") }}</v-card-title>
          <v-container>
            <v-row>
              <v-col cols="2">
                <v-text-field v-model="projectFilterValue" type="text" :label="$t('common.projectName')" append-icon="search"></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field v-model="clientFilterValue" type="text" :label="$t('project.client')" append-icon="search"></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-select :items="vesselsFilterData" v-model="vesselFilterValue" :label="$t('nav.vessel')" item-text="Name" item-value="Id" clearable></v-select>
              </v-col>
              <v-col cols="2">
                <v-select :items="projectStatuses" v-model="projectStatusFilterValue" :label="$t('project.status')" item-text="description" item-value="id" clearable></v-select>
              </v-col>
            </v-row>
          </v-container>

          <v-data-table id="projectTable" :headers="headers" :items="items" :items-per-page="-1" class="elevation-1">
            <template slot="item" slot-scope="props">
              <tr>
                <td style="text-align: left">{{ props.item.projectCode }}</td>
                <td style="text-align: left">{{ props.item.projectName }}</td>
                <td style="text-align: left">{{ props.item.client }}</td>
                <td style="text-align: left">{{ props.item.partiesInvolved }}</td>
                <td style="text-align: left">{{ props.item.vessels | namesOfVessels }}</td>
                <td style="text-align: left">{{ props.item.weatherSegments }}</td>
                <td style="text-align: center">{{ props.item | statusOf(statusMap) }}</td>
                <td style="text-align: center">
                  <v-btn id="btnDel" color="primary" x-small fab outlined elevation="1" @click="deleteItemConfirm(props.item)">
                    <template>
                      <v-icon small dark color="primary">{{ props.item.isDeleted ? "lock" : "lock_open" }}</v-icon>
                    </template> </v-btn
                  >&nbsp;
                  <v-btn id="btnEdit" color="primary" x-small fab outlined elevation="1" :disabled="props.item.isDeleted === true" @click="editItem(props.item)">
                    <v-icon small color="primary">mdi-pencil</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>

          <!-- Add/Edit Project Dialog -->
          <v-dialog v-model="editItemDlg" max-width="65%">
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-form @submit.prevent="submit" ref="form">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="editedItem.projectCode" :rules="[() => !!editedItem.projectCode || requiredMessage]" required>
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t("project.code") }}
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="8" md="8">
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="editedItem.projectName" :rules="[() => !!editedItem.projectName || requiredMessage]" required>
                              <template v-slot:label>
                                <v-icon color="red" x-small>mdi-asterisk</v-icon>
                                {{ $t("common.projectName") }}
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="editedItem.client">
                              <template v-slot:label>{{ $t("project.client") }}</template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="editedItem.partiesInvolved">
                              <template v-slot:label>{{ $t("project.partiesInvolved") }}</template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-select :items="projectStatuses" v-model="editedItem.statusId" item-text="description" item-value="id" :readonly="editedIndex != -1">
                              <template v-slot:label>{{ $t("project.status") }}</template>
                            </v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <v-select v-if="editedIndex == -1" :items="weatherSegments" v-model="editedItem.weatherSegments">
                              <template v-slot:label>{{ $t("project.weatherSegments") }}</template>
                            </v-select>
                            <v-text-field v-else v-model="editedItem.weatherSegments" :readonly="true">
                              <template v-slot:label>{{ $t("project.weatherSegments") }}</template></v-text-field
                            >
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <label>{{ $t("nav.vessels") }}</label>
                        <v-list class="sc prj-vessels">
                          <v-list-item v-for="v in availVessels" :key="v.Id">
                            <v-list-item-action>
                              <v-checkbox color="primary" :id="'v-' + v.Id" :value="v.isAssigned" v-model="v.isAssigned"></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-content>
                              <label role="button" :for="'v-' + v.Id">{{ v.Name }}</label>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="close">{{ $t("common.cancel") }}</v-btn>
                <v-btn color="primary" text type="submit" :disabled="!formIsValid" @click="save">{{ $t("common.save") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- /Add/Edit Project Dialog -->

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title>{{ $t("common.sure") }}</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="close">{{ $t("common.cancel") }}</v-btn>
                <v-btn color="primary" text @click="deleteItemConfirm">{{ $t("common.delete") }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-card-actions id="pCardAct">
            <v-row align="center" justify="center">
              <v-btn class="mt-1" id="btnAddProject" color="primary" dark @click="createItem()">{{ $t("project.new") }}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import Vue from "vue";

export default {
  data() {
    return {
      editedIndex: -1,
      editedItem: {},
      defaultItem: { statusId: 1, vessels: [] },

      availVessels: [],

      projectStatusFilterValue: null,
      projectFilterValue: null,
      clientFilterValue: null,
      vesselFilterValue: null,

      editItemDlg: false,
      dialogDelete: false,
      requiredMessage: this.$t("common.required"),
      weatherSegments: [4, 6],

      headers: [
        {
          text: this.$t("project.code"),
          align: "left",
          sortable: true,
          value: "projectCode",
        },
        {
          text: this.$t("common.projectName"),
          align: "left",
          value: "projectName",
          filter: this.projectFilter,
        },
        {
          text: this.$t("project.client"),
          align: "left",
          value: "client",
          filter: this.clientFilter,
        },
        {
          text: this.$t("project.partiesInvolved"),
          align: "left",
          value: "partiesInvolved",
        },
        {
          text: this.$t("nav.vessel"),
          align: "left",
          value: "vessels",
          filter: this.vesselFilter,
        },
        {
          text: this.$t("nav.weatherSegments"),
          align: "left",
          value: "weatherSegments",
        },
        {
          text: this.$t("project.status"),
          align: "center",
          value: "statusId",
          filter: this.projectStatusFilter,
        },
        {
          text: this.$t("column.actions"),
          align: "center",
          value: "actions",
          width: "10%",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "m_project/getProjects",
      "m_project/getProjectStatuses",
      "m_project/getProjectStatusesMap",
      "m_project/getNextSeqCode",

      "m_vessel/getVesselNames",
      "m_vessel/getVesselsFilterData",

      // "getProjects",
      // "getVesselNames",
      // "getVessels",
      "getProjectsInVessel",
      "getProjectById",
      // "getVesselList",

      "getGlobalCtx",
      // "getProjectStatues",
      // "getUnassignedVessels",
      // "getNextSeqCode",
    ]),
    formTitle() {
      return this.editedIndex === -1 ? this.$t("common.new") + " " + this.$t("nav.project") : this.$t("common.edit") + " " + this.$t("nav.project");
    },

    items() {
      return this["m_project/getProjects"];
    },

    projectStatuses() {
      return this["m_project/getProjectStatuses"];
    },

    statusMap() {
      return this["m_project/getProjectStatusesMap"];
    },

    vesselsFilterData() {
      return this["m_vessel/getVesselsFilterData"];
    },

    vesselNames() {
      return this["m_vessel/getVesselNames"];
    },

    formIsValid() {
      return this.editedItem.projectCode && this.editedItem.projectName;
    },
  },
  watch: {
    editItemDlg(val) {
      val || this.close();
    },
  },

  filters: {
    statusOf: function(project, map) {
      return project && project.statusId ? map[project.statusId] : "";
    },
    namesOfVessels: function(vessels) {
      return (vessels || []).map((v) => v.Name).join(", ");
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.mHideLongLoader();
    });
  },
  methods: {
    ...mapMutations(["mHideLongLoader"]),
    ...mapActions(["m_project/fetchNextMaxCode", "m_project/fetchProjects", "m_project/fetchProjectStatuses", "m_project/createProject", "m_project/updateProject", "m_project/deleteProject", "m_project/createProjectVesselMapping", "m_project/deleteProjectVesselMapping", "m_vessel/fetchVesselNames"]),

    resetEntity(item) {
      this.editedItem = Object.assign({}, item || this.defaultItem);
      this.editedIndex = item ? this.items.indexOf(item) : -1;
      if (this.editedIndex == -1) {
        this.editedItem.projectId = this["m_project/getNextSeqCode"];
      }

      var prjVesselIds = [];
      this.editedItem.vessels.forEach((v) => prjVesselIds.push(v.Id));
      this.editedItem.prjVesselIds = prjVesselIds;

      this.availVessels = Object.assign([], this["m_vessel/getVesselNames"]);
      this.availVessels.forEach((av) => {
        av.isAssigned = prjVesselIds.indexOf(av.Id) !== -1;
      });
    },

    //#region Filters
    projectFilter(value) {
      let name = value || "";
      return !this.projectFilterValue || name.toLowerCase().includes(this.projectFilterValue.toLowerCase());
    },

    clientFilter(value) {
      let name = value || "";
      return !this.clientFilterValue || name.toLowerCase().includes(this.clientFilterValue.toLowerCase());
    },

    vesselFilter(prjVessels) {
      return !this.vesselFilterValue || prjVessels.findIndex((pv) => pv.Id == this.vesselFilterValue) != -1;
    },

    projectStatusFilter(prjStatusId) {
      return !this.projectStatusFilterValue || prjStatusId === this.projectStatusFilterValue;
    },
    //#endregion

    editItem(item) {
      Vue.$log.debug("edit project ", item.projectCode, " Init dialog");
      this.resetEntity(item);
      this.editItemDlg = true;
    },

    createItem() {
      this.resetEntity();
      this.editedItem.projectCode = this["m_project/getNextSeqCode"];
      this.editItemDlg = true;
    },

    deleteItemConfirm(item) {
      let projectId = item.id;
      let msg = item.isDeleted ? "warming.unlock" : "warming.lock";

      this.$confirm(this.$t(msg) + this.$t("nav.project") + "?", {
        buttonTrueText: this.$t("common.ok"),
        buttonFalseText: this.$t("common.cancel"),
        color: "warning",
        icon: "warning",
        title: this.$t("common.warning"),
        width: 350,
        property: "$confirm",
      }).then((res) => {
        if (res && item.isDeleted) {
          Vue.$log.debug("project", projectId, "already deleted. Activating it ...");
          item.statusId = 1;
          item.isDeleted = false;
          this["m_project/updateProject"](item);
        }

        if (res && !item.isDeleted) {
          Vue.$log.debug("deleting project", projectId);
          this["m_project/deleteProject"](item);
        }
      });
    },

    close() {
      this.$refs.form.resetValidation();
      this.editItemDlg = false;
    },

    save() {
      Vue.$log.debug("Save/Update project", this.editedItem.id);

      var data = {
        projectCode: this.editedItem.projectCode,
        projectName: this.editedItem.projectName,
        client: this.editedItem.client,
        partiesInvolved: this.editedItem.partiesInvolved || "",
        statusId: this.editedItem.statusId,
        weatherSegments: this.editedItem.weatherSegments || "6",
      };

      console.log(data);
      console.log(this.editItem);

      let promise = null;

      if (~this.editedIndex) {
        data.id = this.editedItem.id;
        promise = this["m_project/updateProject"](data);
      }

      if (!~this.editedIndex) {
        promise = this["m_project/createProject"](data);
      }

      promise.then((project) => this.updateProjectVessels(project.id));

      this.close();
    },

    updateProjectVessels(projectId) {
      Vue.$log.debug("Save/Update veseels for", projectId);
      var assignments = {
        toAdd: [],
        toRemove: [],
      };

      this.availVessels.forEach((av) => {
        let pvIdx = this.editedItem.prjVesselIds.indexOf(av.Id);
        if (av.isAssigned && pvIdx == -1) {
          assignments.toAdd.push({ pId: projectId, vId: av.Id });
        }

        if (!av.isAssigned && pvIdx !== -1) {
          assignments.toRemove.push({ pId: projectId, vId: av.Id });
        }
      });

      Vue.$log.debug("project-vessels assignments", assignments);
      assignments.toAdd.forEach((a) => this["m_project/createProjectVesselMapping"](a));
      assignments.toRemove.forEach((a) => this["m_project/deleteProjectVesselMapping"](a));
    },
  },

  created() {
    Vue.$log.debug("component created. Loading default data ...");
    this["m_project/fetchProjects"]();
    this["m_project/fetchProjectStatuses"]();
    this["m_project/fetchNextMaxCode"]();
    this["m_vessel/fetchVesselNames"]();
  },
};
</script>

<style>
#projectTable {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  margin-top: 20px;
  width: auto;
  height: auto;
}
#projectTable header {
  font-weight: bold;
}
#projectsCard {
  width: auto;
}
.sc {
  height: 150px;
  overflow-y: auto;
}
</style>
